import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Box as f } from "@mui/joy";
import { memo as c } from "react";
import { useDataset as R } from "../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../contexts/FeatureContext/FeatureContext.js";
import "../../../../contexts/FileContext/FileContext.js";
import "../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as F } from "../../../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as h } from "../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../contexts/WorkerContext/WorkerContext.js";
import j from "../../../Prepper/components/FixFailedValuesCheckbox/FixFailedValuesCheckbox.js";
import C from "../../../Prepper/components/DropFailedRowsCheckbox/DropFailedRowsCheckbox.js";
const b = c(() => {
  const {
    schema: e
  } = h(), {
    columns: t
  } = e || {}, {
    autofix: i,
    dropFailedRows: s,
    setAutofix: a,
    setDropFailedRows: p
  } = F(), {
    analyzing: r,
    autofixReport: m,
    validationReport: l
  } = R(), {
    report: n
  } = m || {}, {
    numFixedCellsTotal: x = 0
  } = n || {}, {
    report: u
  } = l || {}, {
    numInvalidRowsTotal: d = 0
  } = u || {};
  return t && t.length > 0 ? /* @__PURE__ */ o.jsxs(f, { sx: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-start"
  }, children: [
    /* @__PURE__ */ o.jsx(j, { autofix: i, disabled: r, numFixedCellsTotal: x, setAutofix: a }),
    /* @__PURE__ */ o.jsx(C, { disabled: r, dropFailedRows: s, numInvalidRowsTotal: d, setDropFailedRows: p })
  ] }) : null;
});
b.displayName = "FixValuesControls";
export {
  b as default
};
//# sourceMappingURL=FixValuesControls.js.map
